import type { TFunction } from "i18next";
import type { BillingInterval, Plan } from "../../../shared/types.js";

/** Matches stored payment descriptions like "basic monthly" or "Provider setup — premium annual renewal". */
const PAYMENT_DESCRIPTION_RE =
  /^(?:Provider setup — )?(basic|premium) (monthly|annual)(?: renewal)?$/i;

function localizedPlanInterval(plan: Plan, interval: BillingInterval, t: TFunction): string {
  const planLabel = t(`plans.${plan}`);
  const intervalLabel = t(`plans.${interval}`).toLowerCase();
  return `${planLabel} ${intervalLabel}`;
}

/** Localizes payment history lines stored with English plan/interval slugs. */
export function formatPaymentDescription(description: string, t: TFunction): string {
  const trimmed = (description ?? "").trim();
  if (!trimmed) return trimmed;

  const match = trimmed.match(PAYMENT_DESCRIPTION_RE);
  if (!match) return trimmed;

  const plan = match[1]!.toLowerCase() as Plan;
  const interval = match[2]!.toLowerCase() as BillingInterval;
  const core = localizedPlanInterval(plan, interval, t);

  if (/^Provider setup — /i.test(trimmed)) {
    return t("integrated.paymentHistoryProviderSetup", { plan: core });
  }
  if (/ renewal$/i.test(trimmed)) {
    return t("integrated.paymentHistoryRenewal", { plan: core });
  }
  return core;
}
